module.exports = __webpack_public_path__ + "static/media/nodejs.94cafb0d.svg";